import React, { useEffect, useRef, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { AutoCompleteSelect, ColumnItem } from '../../../../../components';
import { CloseIcon, CompletedIcon, OutstandingIcon } from '../../../../../components/Icon';
import { baseCssOccupieddischarge } from '../baseCss';
import BedStatusIcon from '../../BedStatusIcon';
import { i18n } from '../../../../../language';
import { bedP as P, remarkType } from '../../../bsApp';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import { bedStatusAPI, systemAPI } from '../../../../../apis';
import BookingTable from '../../BookingTable';
import { alertMsg, ResponseCommCodeEnum } from '../../../../../apis/commlogic';
import { revampTableList } from '../../../../../utils/newBedStatusUtil';
import LinkedBedPopup from './LinkedBedPopup';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  root: {
    minWidth: '60rem',
    display: 'flex',
    height: '49.375rem',
    borderRadius: '0.937rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '2.438rem 0 0 0',
    overflow: 'auto',
    minWidth: '30rem',
    flex: '1 1 65%',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1.563rem 0 1.5rem',
    borderLeft: 'solid 1px #ddd',
    minWidth: '15rem',
    maxWidth: '28rem',
    flex: '1 1 35%',
  },
  bedBoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '6.438rem',
    borderRadius: '0.937rem',
    backgroundColor: '#f5faff',
    padding: '0 1.536rem 0 0',
  },
  closeIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '2.75rem 0 2.5rem 0',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconButton: {
    color: '#538fff',
    fontSize: '1.375rem',
    marginRight: '-10px',
  },
  columnTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '1.5',
    color: '#525e6c',
  },
  columnItem: {
    flex: '1 1',
    display: 'flex',
    justifyContent: 'center',
  },
  bedStatus: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '1.25',
    color: '#2e4469',
  },
  columnBox: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    borderRadius: '0.937rem',
    border: '1.2px solid rgb(228, 231, 235)',
  },
  line: {
    width: '1px',
    background: '#e4e7eb',
    margin: '1rem 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  btnGrops: {
    display: 'flex',
    flex: '1',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: '1.625rem',
    '& > :nth-child(1)': {
      marginRight: '1.219rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 1.25rem',
    },
  },
}));

const saveRemark =
  ({ InputValues, allData, setPopup, confirmHandle }) =>
  ({ bedStatusId = 0 }) => {
    if (InputValues.transferRequestId && allData.linkeds && bedStatusId === 0) {
      setPopup(true);
    } else {
      confirmHandle({
        ...allData,
        ...InputValues,
        remarkType: remarkType.tbcAvailable,
        linkedBedStatusId: bedStatusId,
        action: bedStatusId === 0 ? InputValues.action : 0,
      });
    }
  };

export default function Updatetotbc({ closePop, allData, open, confirmHandle }) {
  const baseClasses = baseCssOccupieddischarge();
  const classes = useStyles();
  const columnTitle = [i18n.t('BEDSTATUS_OUTSTANDING'), i18n.t('BEDSTATUS_COMPLETED_SINCE_HOURS_AGO')];
  const iconBgColors = ['#5cd9f4', '#44d7b6'];
  const tableRef = useRef(null);
  const PAGESIZE = 20;
  const [count, setCount] = useState(null);
  const [HospitalWardList, setHospitalWardList] = useState(null);
  const [BsBookingList, setBsBookingList] = useState([]);
  const [BsDiagnosisList, setBsDiagnosisList] = useState(null);
  const [BsRemarkList, setBsRemarkList] = useState(null);
  const [BsMlookupList, setBsMlookupList] = useState(null);
  const [, setIsEditPop] = useState(false);
  const [columnData, setColumnData] = useState([
    { id: 3, IconCom: OutstandingIcon, text: 0 },
    { id: 4, IconCom: CompletedIcon, text: 0 },
  ]);
  const [popup, setPopup] = useState(false);

  const getBsMlookupList = async () => {
    try {
      const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(getBsMlookupList.result);
    } catch {}
  };
  const getBsBookingList = async (pageSize, pageNo) => {
    try {
      const { result } = await bedStatusAPI.getBsTransferRequestTbcList({
        pageNo: pageNo,
        pageSize: pageSize,
        bedStatusId: allData?.bedStatusId,
        // startDate: moment(moment().subtract(1, 'days').format('yyyy-MM-DD 00:00:00')).valueOf(),
        // endDate: moment(moment().add(1, 'days').format('yyyy-MM-DD 23:59:59')).valueOf(),
      });
      setCount(result?.count);
      setColumnData([
        { ...columnData[0], text: result?.outstandingCount ?? 0 },
        { ...columnData[1], text: result?.completedCount ?? 0 },
      ]);
      const decryptedData = await revampTableList(result.data);
      const newBsBookingList = [...BsBookingList.slice(0, (pageNo - 1) * pageSize), ...decryptedData];
      newBsBookingList.forEach((element) => {
        element.changeIdStatus = element?.checkBedStatusId === allData?.bedStatusId;
      });
      setBsBookingList(newBsBookingList);
      return decryptedData;
    } catch (e) {
      console.log('-------------', e);
    }
  };
  useEffect(() => {
    (async () => {
      await getBsMlookupList();
    })();
  }, []);
  const editPopChange = (value) => {
    setIsEditPop(value);
  };
  const cancelHandler = () => {
    closePop();
  };

  const [InputValues, setInputValues] = useState({
    [P.bedCleaning]: allData?.[P.bedCleaning] ?? '',
    [P.forClinicalAdmission]: allData?.[P.forClinicalAdmission] ?? '',
    [P.ccWardCd]: allData?.[P.ccWardCd] ?? '',
  });
  useEffect(() => {
    setInputValues({
      [P.bedCleaning]: allData?.[P.bedCleaning] ?? '',
      [P.forClinicalAdmission]: allData?.[P.forClinicalAdmission] ?? '',
    });
  }, [allData]);

  const changeHandle = (type, key) => {
    return (event) => {
      if (type === 'select') {
        setInputValues({ ...InputValues, [key]: event });
      }
    };
  };

  const requestHttp = async () => {
    try {
      const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(getBsMlookupList.result);

      const getBsRemarkList = await bedStatusAPI.getBsRemarkList();
      setBsRemarkList(getBsRemarkList.result.data);

      const getBsDiagnosisList = await bedStatusAPI.getBsDiagnosisList();
      setBsDiagnosisList(getBsDiagnosisList.result.data);

      const getSysHospitalWardList = await systemAPI.getSysHospitalWardList();
      setHospitalWardList(getSysHospitalWardList.result);
    } catch (error) {
      console.log(`---------${error}------------`);
    }
  };
  const nextPageCall = async (pageSize, pageNo) => {
    try {
      if (count === null || count !== BsBookingList.length) {
        if (count === null) {
          await requestHttp();
        }
        await getBsBookingList(pageSize, pageNo);
      }
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };
  const [checkData, setCheckData] = useState('');
  const onChangeCheckbox = (data) => () => {
    setCheckData(data);
    const list = _.map(BsBookingList, (item, index) => {
      return {
        ...item,
        changeIdStatus: item.changeIdStatus ? false : item.transferRequestId === data.id,
      };
    });
    setBsBookingList(list);
  };
  useEffect(() => {
    _.map(BsBookingList, (item, index) => {
      if (item.changeIdStatus) {
        if (item.status === 'O') {
          setInputValues({
            ...InputValues,
            [P.forClinicalAdmission]: item.admissionType,
            transferRequestId: item.transferRequestId,
          });
        } else {
          setInputValues({
            ...InputValues,
            [P.forClinicalAdmission]: '',
            action: 1,
            transferRequestId: null,
          });
        }
      }
      if (item.transferRequestId === checkData.id) {
        if (item.changeIdStatus) {
          setInputValues({
            ...InputValues,
            [P.forClinicalAdmission]: item.admissionType,
            action: 0,
            transferRequestId: item.transferRequestId,
          });
        } else {
          setInputValues({
            ...InputValues,
            [P.forClinicalAdmission]: '',
            action: 1,
            transferRequestId: null,
          });
        }
      }
    });
  }, [BsBookingList]);
  const [hideIndex, setHideIndex] = useState(null);
  const editSaveHandle = async (requestVal, editIndex) => {
    try {
      await bedStatusAPI.postUpdateBsBooking(requestVal);
      const pageNo = Math.ceil((editIndex + 1) / PAGESIZE);
      const temp = await getBsBookingList(PAGESIZE, pageNo);
      const index = temp?.findIndex((item) => item.transferRequestId === requestVal.transferRequestId);
      setHideIndex(index > -1 ? (pageNo - 1) * PAGESIZE + index : index);
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };
  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <div className={classes.left}>
          <Typography className={classes.bedStatus} style={{ marginBottom: '2.313rem', padding: '0 1.563rem' }}>
            {i18n.t('BEDSTATUS_UPDATE_BED_STATUS')}
          </Typography>
          {/* <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_UPDATE_BED_STATUS')}</Typography> */}
          <div style={{ padding: '0 1.563rem' }}>
            <div className={classes.columnBox}>
              {columnData.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    {index === 1 ? <div className={classes.line} /> : ''}
                    <div className={classes.columnItem}>
                      <ColumnItem
                        {...item}
                        title={columnTitle[index]}
                        iconBgColor={iconBgColors[index]}
                        style={{ width: 'unset', margin: '0' }}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <BookingTable
            className={classes.BookingTable}
            allData={BsBookingList}
            hospitalWardList={HospitalWardList}
            BsDiagnosisList={BsDiagnosisList}
            BsRemarkList={BsRemarkList}
            editPopChange={editPopChange}
            bsMlookupList={BsMlookupList}
            ref={tableRef}
            nextPageCall={nextPageCall}
            pageSize={PAGESIZE}
            showCheckbox={true}
            onChangeCheckbox={onChangeCheckbox}
            seeIcon={true}
            saveHandle={editSaveHandle}
            hideIndex={hideIndex}
            currentBed={allData}
            tablePadding={true}
            remarkMinWidth="5rem"
            checkBoxPadding="0.813rem 0rem"
          />
        </div>
        <div className={classes.right}>
          <div className={classes.closeIcon} id="bed_updatetotbc_close">
            <IconButton className={classes.iconButton} onClick={closePop}>
              <CloseIcon />
            </IconButton>
          </div>
          <Box overflow="auto">
            <Typography className={baseClasses.areYouSureYouWou} style={{ marginBottom: '1.75rem' }}>
              {i18n.t('BEDSTATUS_ARE_YOU_SURE_TO_UPDATE_BED__TO_TBC', {
                value: allData?.[P.bedNo] ?? i18n.t('BEDSTATUS_N_A'),
              })}
            </Typography>

            <div className={classes.bedBoBox}>
              <div className={baseClasses.status}>
                <BedStatusIcon allData={allData} disabled={true} />
              </div>
              <Box display="flex" flexDirection="column">
                <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_PATIENT_ID')}</Typography>
                <Typography className={baseClasses.statusText}>N/A</Typography>
              </Box>
            </div>
          </Box>
          <Typography className={baseClasses.others} style={{ margin: '1.85rem 0 0rem 0' }}>
            {i18n.t('BEDSTATUS_REMARKS')}
          </Typography>
          <Typography className={baseClasses.discharge} style={{ margin: '1rem 0 0.85rem 0' }}>
            {i18n.t('BEDSTATUS_BED_CLEANING')}
          </Typography>
          <AutoCompleteSelect
            id="bed_updatetotbc_bed_cleaning"
            itemList={bsMlookupListFunc.getTypeLookupAddBlankFormat(BsMlookupList, 'bs_cleaning')}
            value={InputValues?.[P.bedCleaning]}
            onChange={changeHandle('select', P.bedCleaning)}
            placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEM')}
          />
          <Typography className={baseClasses.discharge} style={{ margin: '1.75rem 0 0.85rem 0' }}>
            {i18n.t('BEDSTATUS_FOR_CLINICAL_ADMISSION')}
          </Typography>
          <AutoCompleteSelect
            id="bed_updatetotbc_for_clinical_admission"
            itemList={bsMlookupListFunc.getTypeLookupAddBlankFormat(BsMlookupList, 'bs_clinical_admission')}
            value={InputValues?.[P.forClinicalAdmission]}
            onChange={changeHandle('select', P.forClinicalAdmission)}
            placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEM')}
          />
          <div className={classes.btnGrops} style={{ boxShadow: '0 -1px 0 0 #e4e7eb' }}>
            <ButtonBase
              id="bed_updatetotbc_cancel"
              className={baseClasses.cancelBtn}
              style={{ marginRight: '1.25rem' }}
              onClick={cancelHandler}
            >
              {i18n.t('BEDSTATUS_CANCEL')}
            </ButtonBase>
            <ButtonBase
              id="bed_updatetotbc_confirm"
              className={baseClasses.configBtn}
              onClick={saveRemark({ InputValues, allData, setPopup, confirmHandle })}
            >
              {i18n.t('BEDSTATUS_CONFIRM')}
            </ButtonBase>
          </div>
        </div>
      </div>
      {popup && (
        <LinkedBedPopup
          allData={allData}
          handleClose={() => setPopup(false)}
          handleSubmit={saveRemark({ InputValues, allData, setPopup, confirmHandle })}
        />
      )}
    </Dialog>
  );
}
